import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => {
  return {
    footer: {
      display: "flex",
      flexFlow: "row nowrap",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      height: 30,
      background: theme.palette.background.paper,
      color: theme.palette.getContrastText(theme.palette.background.paper),
      zIndex: theme.zIndex.drawer + 1,
      borderTop: "thin solid",
      borderTopColor: theme.palette.action.disabledBackground,
      boxSizing: "border-box"
    },
    left: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "center",
      justifyContent: "start"
    }
  };
});
